import ReservesTab from './ReservesTab'

export default ReservesTab
